const MAX_COUNTDOWN_MS = 48 * 3600 * 1000

export function parseResetsAt(raw: string | Date | null | undefined): Date | undefined {
  if (!raw) return undefined
  if (raw instanceof Date) return isNaN(raw.getTime()) ? undefined : raw
  const d = new Date(raw)
  return isNaN(d.getTime()) ? undefined : d
}

export function fallbackResetsAt(now: number = Date.now()): Date {
  const d = new Date(now)
  d.setUTCHours(24, 0, 0, 0)
  return d
}

export function formatCountdown(target: Date, now: number = Date.now()): string {
  const diffMs = target.getTime() - now
  if (diffMs <= 0) return '0s'
  const totalSec = Math.floor(diffMs / 1000)
  const days = Math.floor(totalSec / 86_400)
  const hours = Math.floor((totalSec % 86_400) / 3_600)
  const minutes = Math.floor((totalSec % 3_600) / 60)
  const seconds = totalSec % 60
  if (days > 0) return `${days}d ${hours}h`
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m ${seconds}s`
}

export interface CountdownSources {
  retryAfterSec?: number
  resetsAt?: string | Date
}

export function resolveCountdownTarget(
  sources: CountdownSources,
  now: number = Date.now(),
): Date {
  const ceiling = new Date(now + MAX_COUNTDOWN_MS)

  if (typeof sources.retryAfterSec === 'number' && sources.retryAfterSec > 0) {
    const t = new Date(now + sources.retryAfterSec * 1000)
    return t.getTime() > ceiling.getTime() ? ceiling : t
  }

  const parsed = parseResetsAt(sources.resetsAt)
  if (parsed && parsed.getTime() > now) {
    return parsed.getTime() > ceiling.getTime() ? ceiling : parsed
  }

  return fallbackResetsAt(now)
}
